// extracted by mini-css-extract-plugin
module.exports = {"root":"logo_root__hyd2H"};